import { render, staticRenderFns } from "./OrderUpdate.vue?vue&type=template&id=3edac9ac"
import script from "./OrderUpdate.vue?vue&type=script&lang=js"
export * from "./OrderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports